(() => {
  const SELECTOR = '[data-ecko-hero-carousel]';

  const hydrateSlide = (slide) => {
    if (!slide) return;
    slide.querySelectorAll('img[data-ecko-defer-src]').forEach((img) => {
      const src = img.getAttribute('data-ecko-defer-src');
      const srcset = img.getAttribute('data-ecko-defer-srcset');
      const sizes = img.getAttribute('data-ecko-defer-sizes');
      if (src) img.setAttribute('src', src);
      if (srcset) img.setAttribute('srcset', srcset);
      if (sizes) img.setAttribute('sizes', sizes);
      img.removeAttribute('data-ecko-defer-src');
      img.removeAttribute('data-ecko-defer-srcset');
      img.removeAttribute('data-ecko-defer-sizes');
    });
  };

  const initCarousel = (root) => {
    if (!root || root.dataset.eckoCarouselReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-ecko-slide]'));
    if (slides.length < 2) return;

    root.dataset.eckoCarouselReady = 'true';

    let index = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains('is-active'))
    );
    let timer = null;
    const interval = Math.max(2000, Number(root.dataset.interval) || 5000);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) root.classList.add('ecko-hero-carousel--reduced');

    // First slide is already in HTML; warm the next one after idle so swaps stay smooth.
    hydrateSlide(slides[index]);
    const warmNext = () => hydrateSlide(slides[(index + 1) % slides.length]);
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmNext, { timeout: 2500 });
    } else {
      window.setTimeout(warmNext, 1200);
    }

    const paint = () => {
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) hydrateSlide(slide);
      });
      // Prefetch the following slide while the current one is visible.
      hydrateSlide(slides[(index + 1) % slides.length]);
      root.querySelectorAll('[data-ecko-dot]').forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      root.dataset.activeIndex = String(index);
    };

    const go = (next) => {
      index = ((next % slides.length) + slides.length) % slides.length;
      paint();
    };

    const stop = () => {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    };

    const tick = () => {
      stop();
      timer = window.setTimeout(() => {
        go(index + 1);
        tick();
      }, interval);
    };

    const onVisibility = () => {
      if (document.hidden) stop();
      else tick();
    };

    root.querySelectorAll('[data-ecko-prev]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        go(index - 1);
        tick();
      });
    });
    root.querySelectorAll('[data-ecko-next]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        go(index + 1);
        tick();
      });
    });
    root.querySelectorAll('[data-ecko-dot]').forEach((dot, i) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        go(i);
        tick();
      });
    });

    paint();
    tick();
    document.addEventListener('visibilitychange', onVisibility);

    root._eckoCarouselTeardown = () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
      root.dataset.eckoCarouselReady = 'false';
    };
  };

  const initAll = (scope) => {
    (scope || document).querySelectorAll(SELECTOR).forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SELECTOR).forEach((root) => {
      if (typeof root._eckoCarouselTeardown === 'function') root._eckoCarouselTeardown();
    });
  });
})();
